import { render, staticRenderFns } from "./MenuGridIcon.vue?vue&type=template&id=d35f7a16&"
import script from "./MenuGridIcon.vue?vue&type=script&lang=js&"
export * from "./MenuGridIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports